import { useNavigate } from 'react-router-dom';
import HeaderBarComponent from '../../components/HeaderBarComponent';
import IconHKDC from '../../assets/hkdc/icons/HKDCIcon';
import React from 'react';

export default function WebNavHeaderBarComponent(props) {

  const navigate = useNavigate();

  return (
    <div className='white-block full-width'>
      <HeaderBarComponent
        homeIcon={
          <IconHKDC
            style={{ width: '10.5625rem', height: '5.875rem', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              window.location.assign('https://www.hkdesigncentre.org/ ');
            }}
          />
        }
        homeBarStyle = {{
          height: '8.5rem',
          alignItems: 'center'
        }}
        homeFunctionStyle = {{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: '1.25rem'
        }}
        homeIconStyle = {{
          gap: '0.75rem'
        }}
        iconStyle = {{
          fontSize: '2rem'
        }}
      />
    </div>
  );
}